import Route from 'react-router/lib/Route'
import { loadableCreator } from 'ggx-global/loading/loadable-creator'
import Actions from 'ggx-src/legacy/actions/session'

const LoadableAddressBook = loadableCreator({
  dynamicImport: () =>
    import(/* webpackChunkName: 'users' */ './address-book.component'),
  componentName: 'AddressBook',
})

const prepaidRoutesHandler = store => (_nextState, replace, callback) => {
  const { dispatch } = store
  dispatch(Actions.currentUser())
    .then(callback)
    .catch(callback)
}

const AddressBookRoutes = store => (
  <Route
    path="address-book"
    component={LoadableAddressBook}
    onEnter={prepaidRoutesHandler(store)}
  />
)

export { AddressBookRoutes }
